import {
  getTeams,
  createTeam,
  rename,
  getDetail,
  getLink,
  exitTeam,
  loadAvatars,
  loadMembers
} from '../service/team'
import {
  loadPath
} from '../service/index'
import {
  pageCount
}
from '../../../src/config'

export default {
    namespaced: true,
    state:{
      teams: [],
      teamLoaded: false,
      maxPage: false,
      current: 1,
      teamLoading: false,
      currentTeam: {},
      notfound: false,
      newid: '',
      linking: false,
      filePath: [],
      breads: [],
      avatars: [],
      memberLoading: false,
      members: [],
      mMax: false
    },
    mutations:{
      INIT(state){
        state.teams = []
        state.teamLoaded = false
        state.mMax = false
        state.notfound = false
      },
      TEAMS(state,{teams,concat}){
        state.maxPage = teams.length < pageCount
        state.teams = concat ? state.teams.concat(teams) : teams 
        state.teamLoaded = true
      },
      RM_TEAM(state,tid){
        let list = state.teams.filter(item => item.id != tid)
        state.teams = list
      },
      RENAME(state,{groupid,name}){
        let teams = state.teams
        if (state.currentTeam.teamid == groupid) {
          state.currentTeam = {
            ...state.currentTeam,
            name
          }
        }
        teams.map(item => {
          item.id == groupid ? item.name = name : ''
        })
        state.teams = teams
      },
      LOADING(state,flag){
        state.teamLoading = flag
      },
      SAVE_TEAM(state,data){
        state.notfound = false
        state.currentTeam = {
          ...state.currentTeam,
          ...data
        }
      },
      TEAM_NOTFOUND(state){
        state.notfound = true
      },
      LINK_LOADING(state,flag){
        state.linking = flag
      },
      JUMP_ID(state,id){
        state.newid = id
      },
      CLEAR_TEAMS(state){
        state.teams = []
        state.teamLoaded = false
        state.maxPage = false
        state.current = 1
        state.teamLoading = false
        state.currentTeam = {}
        state.notfound = false
        state.newid = ''
        state.linking = false
        state.filePath = []
        state.breads = []
        state.avatars = []
        state.memberLoading = false
        state.members = []
        state.mMax = false
      },
      SAVE_PATH(state,breads){
        state.breads = breads
      },
      RESET_BREADS(state, fileid) {
        state.breads.map(item => {
          item.fileid === fileid ? item.cos = true : item.cos = false
        })
      },
      UPDATE_BREADS(state) {
        state.breads = []
      },
      SAVE_AVATARS(state,{
        groups,concat
      }){
        state.avatars = concat ? state.avatars.concat(groups) : groups
      },
      SAVE_MEMBERS(state,{members,init}){
        state.mMax = members.length < pageCount
        state.members = init ? members : state.members.concat(members)
      },
      M_LOADING(state,flag){
        state.memberLoading = flag
      },
      UPDATE_MEMBER(state,{role,id}){
        let list = role ? state.members.map(item => {
          item.role = item.id == id ? role : item.role
          return item
        }) : state.members.filter(item => item.id !== id)
        state.members = list
      },
      INIT_MEMBERS(state){
        state.members = []
        state.mMax = false
      }
    },
    actions:{
        getTeams({commit,dispatch,state},{init,concat,count}){
            if ((state.maxPage || state.teamLoading) && !count) {
              return
            }
            concat ? commit('LOADING',true) : ''
            if (init) {
              commit('INIT')
            }
            let offset = count ? 0 : state.teams.length
            getTeams({offset,count: count || pageCount},({status,data}) => {
                commit('LOADING', false)
                if (status == 200) {
                  commit('TEAMS', {
                    teams: data.groups,
                    concat
                  })
                  data.groups.length ? dispatch('getTeamsAvatar',{groups: data.groups, concat}) : ''
                }else{
                  commit('TEAMS', {
                    teams: []
                  })
                  commit('TOAST', {
                    type: 'error',
                    msg: data.result
                  }, {
                    root: true
                  })
                }
            })
        },
        getTeamsAvatar({commit,dispatch},{groups,concat}){
          let str = ''
          groups.map(item => {
            str += `,${item.id}`
          })
          loadAvatars(str.slice(1),({status,data}) => {
            if (status == 200) {
              commit('SAVE_AVATARS',{
                groups: data,
                concat
              })
            }
          })
        },
        createTeam({commit,dispatch,state},paload){
          commit('LOADING', true)
          createTeam(paload,({status,data}) => {
            commit('LOADING', false)
            if (status == 200) {
              dispatch('close',{},{root:true})
              dispatch('getTeams',{
                count: state.teams.length + 1
              })
              commit('JUMP_ID',`${new Date().getTime()}&&${data.id}`)
            } else {
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
          })
        },
        renameTeam({commit,dispatch},{tid:groupid,tname:name}){
          commit('LOADING', true)
          rename({
            groupid,
            name
          },({status,data})=>{
            commit('LOADING', false)
            if (status == 200) {
              commit('RENAME',{groupid,name})
              dispatch('close',{},{root:true})
              commit('TOAST',{
                  type: 'success',
                  msg: 'Renamed'
              },{root:true})
              dispatch('flush', {
                noinit: true,
                action: 'flush',
                smodule: 'events'
              }, {
                root: true
              })

            } else {
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
          })
        },
        getTeamInfo({commit,dispatch,state},tid){
          getDetail(tid,({status,data}) => {
            if (status == 200) {
              commit('SAVE_TEAM',data)
              dispatch('flush', {
                smodule: 'index',
                action: 'loadmore',
                paload: {}
              }, {
                root: true
              })
            }else if (status == 404){
              commit('TEAM_NOTFOUND')
            } else if (data.result == 'notGroupMember') {
              commit('JUMP_ID', `${new Date().getTime()}&&${state.teams[0] && state.teams[0].id}`)
            } else {
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
          })
        },
        inviteLink({commit,dispatch},tid){
          commit('LINK_LOADING',true)
          getLink(tid,({status,data}) => {
            commit('LINK_LOADING', false)
            if (status == 200) {
              commit('SET_EXTRA',{endTitle: `(${data.invite_link.membercount}/${data.invite_link.membercountlimit})`},{root:true})
              commit('SAVE_TEAM', data)
            } else if (status == 404) {
              commit('TEAM_NOTFOUND')
            } else {
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
          })
        },
        loadPath({commit,dispatch},{fid}){
          loadPath({pid: fid},({status,data}) => {
            commit('SAVE_PATH',data.path)
          })
        },
        doexit({commit,dispatch,state,rootState},{groupid,role}){
          commit('LINK_LOADING', true)
          exitTeam({groupid,role,memberid:rootState.user.id},async ({status,data}) => {
            commit('LINK_LOADING', false)
            if (status == 200) {
              dispatch('close',{},{root:true})
              let count = state.teams.length
              commit('RM_TEAM',groupid)
              dispatch('getTeams',{
                count
              })
              let jumpId = state.teams.length ? state.teams[0].id == groupid ? state.teams[1] && state.teams[1].id : state.teams[0].id : 'undefined'
              commit('JUMP_ID', `${new Date().getTime()}&&${jumpId}`)
              commit('TOAST', {
                type: 'success',
                msg: 'DeleteSuc'
              }, {
                root: true
              })
            }else{
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
          })
        },
        loadMembers({commit,dispatch,state},{tid:groupid,init}){
          if (state.memberLoading || state.mMax) {
            return
          }
          let members = state.members
          let offset = init ? 0 : members.length
          commit('M_LOADING',true)
          loadMembers({groupid,offset,count: init && members.length > pageCount ? members.length : pageCount},({status,data}) => {
            commit('M_LOADING', false)
            if (status == 200) {
              commit('SAVE_MEMBERS', {
                members: data.members,
                init
              })
            }
          })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/team.js